import merge from "lodash.merge"
import shortid from "shortid"

import stages from "./stages.js"
import units from "./units.js"

const GRASS_STARTER_ENCOUNTERS = extendEncounters([
    {
        "type": "combat",
        "stage": stages[6],
        "baddies": [
            {"family": "wingull", "level": 1},
            {"family": "wingull", "level": 1},
            {"family": "wingull", "level": 1},
            {"family": "joltik", "level": 1},
        ],
        "rewards": [
            {"family": "wingull", "level": 1},
            {"family": "wingull", "level": 1},
            {"family": "joltik", "level": 1},
        ]
    },
    {
        "type": "combat",
        "stage": stages[17],
        "baddies": [
            {"family": "sandshrew", "level": 1},
            {"family": "horsea", "level": 1},
            {"family": "sandshrew", "level": 1},
        ],
        "rewards": [
            {"family": "sandshrew", "level": 1},
            {"family": "horsea", "level": 1},
            {"family": "sandshrew", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[8],
        "baddies": [
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "sizzlepede", "level": 1},
        ],
        "rewards": [
            {"family": "fletchling", "level": 1},
            {"family": "sizzlepede", "level": 1},
            {"family": "gligar", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[10],
        "baddies": [
            {"family": "oddish", "level": 1},
            {"family": "bounsweet", "level": 1},
            {"family": "bounsweet", "level": 1},
            {"family": "oddish", "level": 1},
        ],
        "rewards": [
            {"family": "bounsweet", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "pichu", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[14],
        "baddies": [
            {"family": "wingull", "level": 1},
            {"family": "wingull", "level": 2},
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "gligar", "level": 1},
        ],
        "rewards": [
            {"family": "wingull", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "oddish", "level": 1},
        ],
        "events": {
            "afterVictory": [
                {"type": "TransitionScreen", "screen": "CreditsScreen"}
            ]
        }
    },
])

const FIRE_STARTER_ENCOUNTERS = extendEncounters([
    {
        "type": "combat",
        "stage": stages[6],
        "baddies": [
            {"family": "bounsweet", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 1},
        ],
        "rewards": [
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "bounsweet", "level": 1},
        ]
    },
    {
        "type": "combat",
        "stage": stages[17],
        "baddies": [
            {"family": "gligar", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "gligar", "level": 1},
        ],
        "rewards": [
            {"family": "gligar", "level": 1},
            {"family": "joltik", "level": 1},
            {"family": "oddish", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[8],
        "baddies": [
            {"family": "wingull", "level": 1},
            {"family": "wingull", "level": 1},
            {"family": "horsea", "level": 1},
        ],
        "rewards": [
            {"family": "horsea", "level": 1},
            {"family": "wingull", "level": 1},
            {"family": "sizzlepede", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[10],
        "baddies": [
            {"family": "gligar", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "gligar", "level": 1},
        ],
        "rewards": [
            {"family": "fletchling", "level": 1},
            {"family": "gligar", "level": 1},
            {"family": "pichu", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[14],
        "baddies": [
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 2},
            {"family": "horsea", "level": 1},
            {"family": "horsea", "level": 1},
            {"family": "wingull", "level": 1},
        ],
        "rewards": [
            {"family": "horsea", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "wingull", "level": 1},
        ],
        "events": {
            "afterVictory": [
                {"type": "TransitionScreen", "screen": "CreditsScreen"}
            ]
        }
    },
])

const WATER_STARTER_ENCOUNTERS = extendEncounters([
    // YOU: WATER
    // THEM: FIRE
    {
        "type": "combat",
        "stage": stages[2],
        "autodeploy": true,
        "baddies": [
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "sizzlepede", "level": 1},
            {"family": "fletchling", "level": 1},
        ],
        "rewards": [
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 1},
            {"family": "sizzlepede", "level": 1},
        ]
    },
    // YOU: WATER, FIRE
    // THEM: FIRE, METAL
    {
        "type": "combat",
        "stage": stages[17],
        "baddies": [
            {"family": "gligar", "level": 1},
            {"family": "sizzlepede", "level": 1},
            {"family": "gligar", "level": 1},
        ],
        "rewards": [
            {"family": "gligar", "level": 1},
            {"family": "sizzlepede", "level": 1},
            {"family": "oddish", "level": 1},
        ],
    },
    // YOU: WATER, FIRE, METAL/GRASS
    // THEM: GRASS
    {
        "type": "combat",
        "stage": stages[8],
        "baddies": [
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "bounsweet", "level": 1},
            {"family": "bounsweet", "level": 1},
        ],
        "rewards": [
            {"family": "bounsweet", "level": 1},
            {"family": "joltik", "level": 1},
            {"family": "oddish", "level": 1},
        ],
    },
    // YOU: WATER, FIRE, METAL/GRASS, GRASS/ELECTRIC
    // THEM: WATER, METAL, GRASS
    {
        "type": "combat",
        "stage": stages[10],
        "baddies": [
            {"family": "gligar", "level": 1},
            {"family": "horsea", "level": 1},
            {"family": "horsea", "level": 1},
            {"family": "gligar", "level": 1},
        ],
        "rewards": [
            {"family": "horsea", "level": 1},
            {"family": "gligar", "level": 1},
            {"family": "sandshrew", "level": 1},
        ],
    },
    {
        "type": "combat",
        "stage": stages[14],
        "baddies": [
            {"family": "fletchling", "level": 1},
            {"family": "fletchling", "level": 2},
            {"family": "oddish", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "bounsweet", "level": 1},
        ],
        "rewards": [
            {"family": "fletchling", "level": 1},
            {"family": "oddish", "level": 1},
            {"family": "bounsweet", "level": 1},
        ],
        "events": {
            "afterVictory": [
                {"type": "TransitionScreen", "screen": "CreditsScreen"}
            ]
        }
    },
    // {
    //     "type": "combat",
    //     "stage": stages[8],
    //     "baddies": [
    //         {"family": "wingull", "level": 1},
    //         {"family": "wingull", "level": 1},
    //         {"family": "sizzlepede", "level": 2},
    //     ],
    //     "rewards": [
    //         {"family": "wingull", "level": 1},
    //         {"family": "sizzlepede", "level": 1},
    //         {"family": "geodude", "level": 1},
    //     ],
    // },
    // electric x2
    // ground x2
    // lifesteal
    // contigious
    // explode
    // change enemy type
    // bind
])

function extendEncounters(encounters) {
    const extendedEncounters = {}
    encounters.forEach((encounter, key) => {
        encounter.key = key
        extendedEncounters[encounter.key] = encounter

        if(encounter.type == "combat") {
            encounter.events = encounter.events || {}
            encounter.events.afterVictory = encounter.events.afterVictory || [{"type": "TransitionScreen", "screen": "EncounterScreen", "encounterKey": key + 1}]

            encounter.stage = encounter.stage || stages[0]

            encounter.baddies = encounter.baddies || []
            encounter.baddies.forEach((unit) => unit.key = unit.key || shortid.generate())

            encounter.rewards = encounter.rewards || []
            encounter.rewards.forEach((unit) => unit.key = unit.key || shortid.generate())
        }

        if(encounter.type == "draft") {
            encounter.draft.units.forEach((unit) => unit.key = unit.key || shortid.generate())
            encounter.events = encounter.events || {}
            encounter.events["end"] = [{"type": "TransitionScreen", "screen": "EncounterScreen", "encounterKey": key + 1}]
        }
    })
    return extendedEncounters
}

function extendGame(game) {
    game.player = game.player || {"affiliation": "good"}

    game.party = game.party || []

    game.events = game.events || {
        "onNewGame": [],
        "onEndGame": [],
    }
    return game
}

export default [
    extendGame({
        "isUnlocked": true,
        "party": [
            {"family": "tepig", "level": 1},
            {"reference": "heal-tamer", "level": 1},
        ],
        "overworld": {
            "encounters": FIRE_STARTER_ENCOUNTERS
        },
    }),
    extendGame({
        "isUnlocked": true,
        "party": [
            {"family": "squirtle", "level": 1},
            {"reference": "fight-tamer", "level": 1},
        ],
        "overworld": {
            "encounters": WATER_STARTER_ENCOUNTERS
        },
    }),
    extendGame({
        "isUnlocked": true,
        "party": [
            {"family": "turtwig", "level": 1},
            {"reference": "dance-tamer", "level": 1},
        ],
        "overworld": {
            "encounters": GRASS_STARTER_ENCOUNTERS
        },
    }),
    extendGame({
        "isUnlocked": false,
        "party": [
            {"family": "sandshrew", "level": 1}
        ],
        "overworld": {
            "encounters": {}
        },
    }),
    extendGame({
        "isUnlocked": false,
        "party": [
            {"family": "pichu", "level": 1}
        ],
        "overworld": {
            "encounters": {}
        },
    }),
]
